import { $api } from "../generated/client";

/**
 * Every shop, active ones first, for a super admin's shop switcher (BAB-3035):
 * about a thousand, loaded once and filtered as one types.
 * Disabled for anyone else: the route is behind SuperAdminGuard.
 */
export function useSuperAdminAllShops(isEnabled: boolean) {
  return $api.useQuery(
    "get",
    "/super-admin/shops/search",
    {},
    { enabled: isEnabled, staleTime: 5 * 60_000 },
  );
}
